import { GridCellProps } from '@progress/kendo-react-grid';
import { useCallback } from 'react';
import GridCellBase from 'src/components/GridCellBase';
import Button, { isButtonDisabled } from 'src/components/design-system/Button';
import PopUp from 'src/components/design-system/PopUp';
import useConfirm from 'src/hooks/useConfirm';
import useReceiptDetails from 'src/hooks/useReceiptDetails';
import { ReceiptLineItem } from 'src/services/useReceiptLineItemsApi';

const DeleteConfirmation: React.FC<GridCellProps> = (props) => {
  const { dataItem, dataIndex } = props;
  const { confirm } = useConfirm();

  const { setReceiptLineItems } = useReceiptDetails();

  const deleteItem = useCallback(
    (item: ReceiptLineItem) => {
      const { rowId } = item;
      setReceiptLineItems((lineItems: ReceiptLineItem[]) =>
        lineItems.filter((lineItem: ReceiptLineItem) => lineItem?.rowId !== rowId)
      );
    },
    [setReceiptLineItems]
  );

  const handleClick = useCallback(() => {
    confirm({
      title: 'Delete Line Item',
      content: (
        <div className="p-2">
          {!!dataItem?.quantityReceived && <div>This line item has a quantity assigned to it.</div>}
          <div>Are you sure you want to delete this line item?</div>
        </div>
      ),
      confirmButtonText: 'OK',
      cancelButtonText: 'Cancel',
      cancelColor: 'info',
    }).then((isDeleteAccepted) => {
      if (isDeleteAccepted && dataIndex !== undefined) {
        deleteItem(dataItem);
      }
    });
  }, [confirm, dataIndex, dataItem, deleteItem]);

  return (
    <GridCellBase {...props} className="overflow-visible-imp">
      <PopUp
        show={isButtonDisabled(dataItem?.canDeleteReceiptLineItem)}
        content={'You cannot delete a line item which is on another completed record.'}
      >
        <Button
          buttonState={dataItem?.canDeleteReceiptLineItem}
          color="error"
          onClick={handleClick}
          size="md"
        >
          Delete
        </Button>
      </PopUp>
    </GridCellBase>
  );
};

export default DeleteConfirmation;
